<div>
    While paused, this device won't receive policy updates. Local changes you make will persist until policy resume.
</div>
<div class="mt-3">
    <label for="policy-pause-duration">Duration</label>
    <input id="policy-pause-duration" type="number" class="mx-2" [attr.min]="POLICY_PAUSE_TIME_MIN"
        [attr.max]="POLICY_PAUSE_TIME_MAX" [value]="_pauseDuration"
        (change)="changePolicyPauseDuration($event.target.value)">
    <span>min</span>
    <small class="ml-2 red-1">({{POLICY_PAUSE_TIME_MIN}} - {{POLICY_PAUSE_TIME_MAX}} minutes are allowed)</small>
</div>